export const TURF_ILLEGAL_ARGUMENT_EXCEPTION = 'IllegalArgumentException';
